import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppSuiteRfbModule } from 'src/app/app-suite-rfb.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

// NOTE: foi usado 'pt' e nao 'pt-BR' isso pq 'pt' tem as definicoes do brasil
// portugal deveria usar 'pt-PT'
import { registerLocaleData, DatePipe } from '@angular/common';
import localesPt from '@angular/common/locales/pt';
import { AppendTokenInterceptor } from './auth/append-token.interceptor';
import { AuthModule } from './auth/auth.module';
import { SharedModule } from './shared/shared.module';

registerLocaleData(localesPt, 'pt-BR');

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppSuiteRfbModule,
        AppRoutingModule,
        AuthModule,
        SharedModule,
        HttpClientModule,
        DashboardModule,
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AppendTokenInterceptor,
            multi: true
        },
        DatePipe,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
